import {HttpInterceptorFn} from "@angular/common/http";
import {environment} from "src/environments/environment";
import {API_ENDPOINTS} from "../app.constants";

export const versionHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith(environment.apiGateway + API_ENDPOINTS.ASSET_MANAGEMENT) && req.method !== "OPTIONS") {
    const newRequest = req.clone({
      setHeaders: {
        //"api-version": environment.apiVersion
        //"x-ms-version": environment.apiVersion
      },
      setParams: {
        "api-version": environment.apiVersion
      }
    });

    return next(newRequest);
  }

  return next(req);
};
